import * as React from "react";

export const Image = ({ src, alt, className }) => (
  <img
    loading="lazy"
    src={src}
    alt={alt}
    className={`object-contain ${className}`}
  />
);